export enum FieldImageProportion {
    // Exact accordance
    precise = 'precise',

    // Not greater than
    less = 'less',
}
